<template>
    <div class="container mt-5">
        <div>
            <b-button v-b-modal.modal-1>Show Modal</b-button>
            <b-modal id="modal-1" title="Vue Js Bootstrap Modal Example">
                <p class="my-4">Content goes here...</p>
            </b-modal>
        </div>
    </div>
</template>

<script>
export default {
    name: "ImageView",
    components: {}
};
</script>
